var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"model":_vm.model,"attribute":_vm.attribute,"type":"select2","display-field":"${item.value}","value-field":"value","items":_vm.computedTitles}})}
var staticRenderFns = []

export { render, staticRenderFns }